/**
 * FT18 fix round (FSD 3.2.1.9, AI-T01-07): the treasury movement anomaly review.
 * The router spreads `CASH_MOVEMENT_ANOMALY_ROUTES`; nav id `cash-movement-anomalies`
 * (s-3.2.1, code AI-T01-07) points here. Reading is `cash.account.read`, the
 * permission of `GET /cash-movement-anomalies`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CASH_PERMISSIONS } from '@/modules/cash/permissions'

export const CASH_MOVEMENT_ANOMALIES_PATH = '/treasury/movement-anomalies'

export const CASH_MOVEMENT_ANOMALY_ROUTES: RouteRecordRaw[] = [
  {
    path: CASH_MOVEMENT_ANOMALIES_PATH,
    name: 'cash-movement-anomalies',
    component: () => import('@/modules/cash/anomalies/MovementAnomaliesView.vue'),
    meta: { titleKey: 'cash.movementAnomalies.routeTitle', permission: CASH_PERMISSIONS.accountRead },
  },
]

/**
 * The review scoped to one legal entity and, optionally, one bank account — the
 * link an attention item about a finding should open (open findings only).
 */
export function movementAnomaliesRoute(scope?: { companyId?: number | null; bankAccountId?: number | null }): string {
  const params = new URLSearchParams()
  if (scope?.companyId != null && scope.companyId > 0) params.set('companyId', String(scope.companyId))
  if (scope?.bankAccountId != null && scope.bankAccountId > 0) {
    params.set('bankAccountId', String(scope.bankAccountId))
  }
  const query = params.toString()
  return query === '' ? CASH_MOVEMENT_ANOMALIES_PATH : `${CASH_MOVEMENT_ANOMALIES_PATH}?${query}`
}
